module.exports = __webpack_public_path__ + "img/pop-up-ajanlat-ikon.382e00e3.svg";